import { cn } from '../../utils/cn/cn.js';

export const cnBubble = cn('bubble');
